import dayjs from 'dayjs';
import { Type } from './Type';

const defaultDateFormat = "YYYY-MM-DD";
const timezoneOffsetInMinutes = new Date().getTimezoneOffset();

export let dateFormat = defaultDateFormat;

export const setDateFormat = (fmt: string) => {
	dateFormat = fmt || defaultDateFormat;
}

export const convertUTCDateToLocalDate = (date: Date | string) => {
	if (Type.isString(date)) {
		date = new Date(date);
		date.setMinutes(date.getMinutes() + timezoneOffsetInMinutes);
	}
	return date;
}

export const convertLocalDateToUTCDate = (date: Date | string): Date => {
	const d = Type.isString(date) ? new Date(date) : date;
	d.setMinutes(d.getMinutes() - timezoneOffsetInMinutes);
	return d;
}

export const toIsoStringDate = (d: string | Date): string => {
	const str = (v: number) => v < 10 ? "0" + v : v;
	if (Type.isString(d)) {
		if (d.length >= 10 && d[4] === '-' && d[7] === '-')
			return d.substring(0, 10);
		d = new Date(d);
	}
	return `${d.getFullYear()}-${str(d.getMonth())}-${str(d.getDate())}`;
}

export const toLocalDate = (utcDate: string): string => {
	return utcDate ? dayjs(utcDate).format(dateFormat) : "";
}

export const toExpirationDate = (utcDate: string): string => {
	if (utcDate) {
		const d = dayjs(utcDate);
		return d.year() > 2500 ? "Unlimited" : d.format(dateFormat);
	}
	return "";
}